import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import Handlebars from 'handlebars';

Snappy.Component.Faqs = class Faqs extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-faqs';
	}
	
	constructor(element) {
		super(element);
	}
	
	render() {
		this.setVars();
		this.prepareFaqsTemplate();
		this.addEventListeners();
		this.initDropdown();
	}
	
	setVars() {
		this.$searchForm = this.$element.find('.fa-faqs__search-form');
		this.$searchFilter = this.$searchForm.find('#faq-query');
    this.$faqFolderId = this.$searchForm.find('#faq-FolderId');
		this.$searchFilterParent = this.$searchFilter.closest('.filter-container');
		this.$dropdownMenu = this.$searchForm.find('.fa-dropdown__select');
		this.$dropdownMenuParent = this.$dropdownMenu.closest('.filter-container');
		this.$faqAccordion = this.$element.find('#faq-accordion');
		this.queryServiceUrl = this.$searchForm.attr('action');
		this.activeFilerClass = 'active';
		this.errorClass = 'error-faqs';
		this.errorElement = this.$element.find('.fa-faqs__error-display');
	}
	
	prepareFaqsTemplate() {
		const source = this.$element.find('#accordion-item-template').html();
		this.faqsTemplate = Handlebars.compile(source);
	}
	
	addEventListeners() {
		this.$dropdownMenu.on('change', this.onTopicChange.bind(this));
		this.$searchForm.on('submit', this.onSearchFormSubmit.bind(this));
	}
	
	initDropdown() {
		this.defaultOption = this.$dropdownMenu.find('option').eq(0).val();
		this.$firstSelectableOption = this.$dropdownMenu.find('option').eq(1);
		this.$dropdownMenu.val(this.$firstSelectableOption.val());
		this.onTopicChange();
	}
	
	resetDropdown() {
		this.$dropdownMenu.val(this.defaultOption);
	}
	
	onTopicChange() {
		const queryObj = {
        topic: this.$dropdownMenu.val(),
        faqFolderId: this.$faqFolderId.val()
		};
		
		this.$dropdownMenuParent.addClass(this.activeFilerClass);
		this.$searchFilterParent.removeClass(this.activeFilerClass);
		this.clearSearchForm();
		this.clearFaqAccordion();
		this.makeRequestForData(queryObj);
	}
	
	onSearchFormSubmit(event) {
		const queryObj = {
        searchTerm: this.$searchFilter.val(),
        faqFolderId: this.$faqFolderId.val()
		};
		
		event.preventDefault();
		
		this.resetDropdown();
		this.$searchFilterParent.addClass(this.activeFilerClass);
		this.$dropdownMenuParent.removeClass(this.activeFilerClass);
		this.clearFaqAccordion();
		this.makeRequestForData(queryObj);
	}
	
	clearSearchForm() {
		this.$searchFilter.val('');
	}
	
	clearFaqAccordion() {
		this.$faqAccordion.empty();
	}
	
	makeRequestForData(query) {
		this.isLoadingData = true;
		this.toggleIsLoadingData();
		this.errorElement.removeClass(this.errorClass);
		
		$.ajax({
			method: 'GET',
			url: this.queryServiceUrl,
			data: query
		}).then(
			this.handleQuerySuccessResponse.bind(this),
			this.handleQueryError.bind(this)
		);
	}
	
	handleQuerySuccessResponse(data) {
		window.setTimeout(function() {
			let markup;
			
			this.isLoadingData = false;
			this.toggleIsLoadingData();
			
			if (data && data.faqItems && data.faqItems.length) {
				markup = data.faqItems.map((item, index) => {
					let modifiedMarkup = this.faqsTemplate(item);
					return modifiedMarkup.replace(/<%index%>/g, index);
				});
				
				markup = markup.join('');
				this.$faqAccordion.append(markup);
			} else {
				this.handleQueryError();
			}
		}.bind(this), 2000);
	}
	
	handleQueryError() {
		this.isLoadingData = false;
		this.toggleIsLoadingData();
		this.errorElement.addClass(this.errorClass);
	}
	
	toggleIsLoadingData() {
		this.$element.toggleClass('loading-faqs', this.isLoadingData);
	}
};



// WEBPACK FOOTER //
// ./components/faqs/scripts/faqs.js